'use strict';


module.exports = function (client) {

    client.disco.addFeature('urn:xmpp:delay');
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/delayed.js
// module id = 578
// module chunks = 2